export const isSizedScreen = (currentScreen, searchScreens) => {
    return searchScreens.indexOf(currentScreen) >= 0;
}
